module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Distribution au point de coordonnées","no-data-title":"Aucune donnée","altitude-unit":"msm","elevation-label":"Altitude [msm]","percentile-label":"Percentile [%]","probability-label":"Probabilité [%]","conversion-title":"Conversion","elevation-placeholder":"Saisir une altitude"},"de":{}}')
  delete Component.options._Ctor
}
